var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChevronUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.23247 5.74076L7.99899 5.51056L7.76497 5.74021L2.41497 10.9902L2.41496 10.9902L2.41274 10.9924C2.31791 11.0872 2.17896 11.0872 2.08414 10.9924C1.98959 10.8979 1.98932 10.7595 2.08331 10.6647L7.83206 5.01589L7.83207 5.01589L7.83414 5.01383C7.92896 4.919 8.06791 4.919 8.16273 5.01383L8.16273 5.01384L8.16481 5.01589L13.9127 10.6638C13.913 10.6641 13.9133 10.6644 13.9136 10.6647C14.0076 10.7595 14.0073 10.8979 13.9127 10.9924C13.8632 11.0419 13.7944 11.0698 13.7484 11.0698C13.6896 11.0698 13.6386 11.0554 13.5689 11.0024L8.23247 5.74076Z",
    fill: "#6B7280",
    stroke: "#6B7280",
    strokeWidth: 0.666667
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronUp);
export default __webpack_public_path__ + "static/media/chevron-up.94ea003e59125f9a66d39dba19d125bc.svg";
export { ForwardRef as ReactComponent };